// extracted by mini-css-extract-plugin
export default {"bg":"Bg_bg__OuVUS","white":"Bg_white__+WYL+","logo":"Bg_logo__eM56-"};